import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { HttpError } from 'models/HttpError';

interface ResponseWrapper<T> {
  success: boolean;
  content: T
  errors: any[]
}

class HttpService {
  options: AxiosRequestConfig = {
    withCredentials: true,
    baseURL: '/api/v1'
  };

  async handler<T>(axiosResponse: Promise<AxiosResponse<ResponseWrapper<T>>>): Promise<T> {
    const response = await axiosResponse;
    if (response.data && response.data.errors) {
      console.debug(response.data.errors);
      throw new HttpError(response.data.errors);
    }
    return response.data.content || (response.data as any as T);
  }

  get<T>(url: string) {
    return this.handler<T>(Axios.get(url, this.options));
  }

  post<T, R = any>(url: string, body?:T) {
    return this.handler<R>(Axios.post(url, body, this.options));
  }
}

export const httpService = new HttpService();
